export default __webpack_public_path__ + "static/media/s6l.a2e9e930.png";